import { Attribute, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslatedString, untranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-input',
  templateUrl: 'cs-input.html',
  host: { 'class': 'input' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CsInputComponent {

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() disabled: boolean = false;
  @Input() type: string = 'text';
  @ViewChild('input') input: ElementRef;
  @Input() placeholder: TranslatedString = untranslatedString('');
  @Input() autocomplete: string = 'on';
  @Input() readonly: boolean = false;
  @Input() name: string;
  @Input() min: number;
  @Input() max: number;
  @Input() checked: boolean;
  @Input() iconName: string;
  // for a box that drives a list of suggestions below it (a combobox): these are set on the inner
  // <input>, which is what a screen reader focuses. Unset, the attributes are left off.
  @Input() ariaRole: string;
  @Input() ariaExpanded: boolean;
  @Input() ariaControls: string;
  @Input() ariaActiveDescendant: string;

  @Output() blur: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() focus: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(
    @Attribute('text-left') public textLeft: boolean,
    @Attribute('text-right') public textRight: boolean,
    public elementRef: ElementRef) { }

  ngOnInit() {
    if (this.value === undefined || this.value === null) {
      this.value = '';
    }
  }

  handleChangeEvent(ev: Event) {
    this.value = (ev.target as HTMLInputElement).value;
    this.valueChange.emit(this.value);
  }

  handleBlur(ev: Event) {
    this.blur.emit(ev);
  }
  handleFocus(ev: Event) {
    this.focus.emit(ev);
  }

  setFocus() {
    this.input.nativeElement.focus();
  }

  setBlur() {
    this.input.nativeElement.blur();
  }

  getNativeElement() {
    return this.input.nativeElement;
  }

}